// components/currentInput
// привязываем к инпуту символы из паттерна

export default function currentInput ($) {

  var name = 'currentInput';

  var methods = {

    init: function (options) {

      if (this.data(name)) return this;

      this.data(name, {
        target: this,
      })

      return this.each( el => {
        // el.bind(`replace.${name}`, methods.replace);
        return methods.replace.apply(this, [options])
      })
    },

    destroy: function () {

      return this.each(function () {

        $(this).unbind('.' + name)
        return this
      })
    },

    replace: function (options) {

      options = $.extend({
        pattern: '',
      }, options)

      this.bind('keyup.' + name, function () {
        var correct = this.value.replace(options.pattern, '')
        if (this.value != correct) {
           this.value = correct
        }
      })
    }
  }

  $.fn.currentInput = function (method) {

    // логика вызова метода
    if ( methods[method] ) {
      return methods[ method ].apply( this, Array.prototype.slice.call( arguments, 1 ));
    } else if ( typeof method === 'object' || ! method ) {
      return methods.init.apply( this, arguments );
    } else {
      $.error( 'Метод с именем ' +  method + ' не существует для jQuery.currentInput' );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/CurrentInput.js
 **/